import React from "react";
import NoContentWarning from "components/NoContentWarning";

const NoChaptersWarning = () => (
  <NoContentWarning warning="No chapters available at this time." />
);

export default NoChaptersWarning;
